import {useEffect, useState} from "react";
import api from "../api/api";
import Header from "./Components/Header";
import '../styles/ContactUs.css';
import {IMAGE_URL} from "../path";
import {Link} from "react-router-dom";
import FooterWithSignup from "./Components/FooterWithSignup";
import cartonBackground from "../assets/images/carton-background.jpg";

type pageHeaderData = {
    header_body: string;
    cover_image: string;
}

type contactUsBody = {
    email: string;
    phone: string;
    fax: string;
    office_name: string;
    office_link: string;
}

type contactUsResponse = {
    message: string;
    page: pageHeaderData | null;
    contact: contactUsBody | null;
}

function ContactUs() {
    const [contact, setContact] = useState<contactUsBody | null>(null);
    const [page, setPage] = useState<pageHeaderData | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchContactUs = async () => {
        try {
            const response = await api.get<contactUsResponse>("/fetch-contact-us");

            setContact(response.data.contact);
            setPage(response.data.page);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContactUs();
    }, [])

    return (
        <div>
            <div className="contact-us-header"
                 style={{
                     backgroundImage: page?.cover_image
                         ? `url(${IMAGE_URL}${page?.cover_image})`
                         : `url(${cartonBackground})`,
                 }}>
                <Header />
                <div className="contact-us-header-inner">
                    <h1>Contact Us</h1>
                    <p>{page?.header_body}</p>
                    <Link to={`mailto:${contact?.email}`} className={"contact-us-link"}>
                        {contact?.email}
                    </Link>
                </div>

            </div>
            <div className="contact-us-body">
                <div className="contact-us-map-frame">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3315.717506551!2d18.689305875705372!3d-33.793792473255344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc566977ca8eb1%3A0x242cecbf48c2e02c!2sDenny%20Mushrooms!5e0!3m2!1sen!2sza!4v1784018456482!5m2!1sen!2sza"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                        title="Denny Foods Head Office"
                    />
                </div>
                <div className="contact-us-map-information">
                    <h2>DENNY Foods Head Office</h2>
                    <div className="contact-us-map-information-item">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16">
                                <path id="Path_14071" data-name="Path 14071" d="M22.25,6.75v10.5a2.279,2.279,0,0,1-2.308,2.25H4.558A2.279,2.279,0,0,1,2.25,17.25V6.75m20,0A2.279,2.279,0,0,0,19.942,4.5H4.558A2.279,2.279,0,0,0,2.25,6.75m20,0v.243a2.238,2.238,0,0,1-1.1,1.916L13.46,13.524a2.358,2.358,0,0,1-2.421,0L3.347,8.91a2.238,2.238,0,0,1-1.1-1.916V6.75" transform="translate(-1.75 -4)" fill="#436AB3" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                            </svg>

                        </div>
                        <div className="info">
                            <h4>Email: </h4>
                            <p><a className="contact-link" href={`mailto:${contact?.email}`}>{contact?.email}</a></p>
                        </div>
                    </div>
                    <div className="contact-us-map-information-item">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                                <g id="Path_14070" data-name="Path 14070" transform="translate(-1.25 -1.25)" fill="#436AB3" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M 19.94231033325195 22.75 L 17.63462066650391 22.75 C 13.39182090759277 22.75 9.402871131896973 21.09768104553223 6.402600765228271 18.0974006652832 C 3.402320861816406 15.09713077545166 1.750000953674316 11.10818099975586 1.750000953674316 6.865380764007568 L 1.750000953674316 4.557691097259521 C 1.750000953674316 3.009521007537842 3.009521007537842 1.750000953674316 4.557691097259521 1.750000953674316 L 5.964870929718018 1.750000953674316 C 6.724950790405273 1.750240921974182 7.384490966796875 2.265300989151001 7.568901062011719 3.002511024475098 L 8.70327091217041 7.538970947265625 C 8.865711212158203 8.187200546264648 8.624860763549805 8.864411354064941 8.089631080627441 9.263991355895996 L 6.764410972595215 10.25816059112549 C 6.545830726623535 10.42210102081299 6.457251071929932 10.69081115722656 6.543951034545898 10.92683124542236 C 7.744771003723145 14.19310092926025 10.3068904876709 16.75522041320801 13.57330131530762 17.95610046386719 C 13.63250064849854 17.97784042358398 13.69443130493164 17.9888916015625 13.75724124908447 17.9888916015625 C 13.94172096252441 17.9888916015625 14.1228609085083 17.89421081542969 14.24179077148438 17.73564147949219 L 15.23671054840088 16.4094409942627 C 15.54698085784912 15.99497127532959 16.0417308807373 15.74729061126709 16.55986022949219 15.74729061126709 C 16.69481086730957 15.74729061126709 16.82978057861328 15.76392078399658 16.96102142333984 15.79673099517822 L 21.49745178222656 16.93110084533691 C 22.23483085632324 17.11507034301758 22.75 17.77470016479492 22.75 18.53513145446777 L 22.75 19.94231033325195 C 22.75 21.49048042297363 21.49048042297363 22.75 19.94231033325195 22.75 Z" stroke="none"/>
                                    <path d="M 4.55769157409668 2.250001907348633 C 3.283191680908203 2.250001907348633 2.250001907348633 3.283191680908203 2.250001907348633 4.55769157409668 L 2.250001907348633 6.865381240844727 C 2.250001907348633 15.36180114746094 9.138200759887695 22.25 17.63462066650391 22.25 L 19.94231033325195 22.25 C 21.21681022644043 22.25 22.25 21.21681022644043 22.25 19.94231033325195 L 22.25 18.53513145446777 C 22.25 18.00590133666992 21.89000129699707 17.54436111450195 21.37615013122559 17.41616058349609 L 16.83975028991699 16.28180122375488 C 16.38845825195312 16.16898155212402 15.91460990905762 16.33821105957031 15.63667106628418 16.70949172973633 L 14.64179134368896 18.03564071655273 C 14.35256004333496 18.42127990722656 13.85307598114014 18.5915412902832 13.40077114105225 18.42539024353027 C 10.00243091583252 17.17601013183594 7.323991775512695 14.49758052825928 6.074611663818359 11.09923076629639 C 5.90846061706543 10.64692115783691 6.078720092773438 10.14744091033936 6.464361190795898 9.858201026916504 L 7.790510177612305 8.863330841064453 C 8.162820816040039 8.585380554199219 8.331020355224609 8.110511779785156 8.21820068359375 7.660261154174805 L 7.083841323852539 3.12384033203125 C 6.955410003662109 2.610401153564453 6.494131088256836 2.250171661376953 5.964870452880859 2.250001907348633 L 4.55769157409668 2.250001907348633 M 4.55769157409668 1.250001907348633 L 5.964870452880859 1.250001907348633 C 6.954870223999023 1.250320434570312 7.813800811767578 1.92108154296875 8.053951263427734 2.881181716918945 L 9.18833065032959 7.417671203613281 C 9.399870872497559 8.261890411376953 9.086060523986816 9.144070625305176 8.388740539550781 9.664650917053223 L 7.064460754394531 10.65813064575195 C 7.022510528564453 10.68959140777588 7.005260467529297 10.732590675354 7.013280868530273 10.75442123413086 C 8.163360595703125 13.88268089294434 10.6173210144043 16.33663177490234 13.74583053588867 17.4868106842041 C 13.74979114532471 17.48826026916504 13.75316143035889 17.4888916015625 13.75725078582764 17.4888916015625 C 13.77873134613037 17.4888916015625 13.81435108184814 17.47223091125488 13.8417911529541 17.43564033508301 L 14.83675098419189 16.10939025878906 C 15.24063110351562 15.5698709487915 15.88501071929932 15.24729061126709 16.55986022949219 15.24729061126709 C 16.73567199707031 15.24729061126709 16.91144180297852 15.26895141601562 17.08229064941406 15.31166076660156 L 21.61874008178711 16.44602966308594 C 22.5789909362793 16.68560028076172 23.25 17.54472160339355 23.25 18.53513145446777 L 23.25 19.94231033325195 C 23.25 21.76618194580078 21.76618194580078 23.25 19.94231033325195 23.25 L 17.63462066650391 23.25 C 13.25826072692871 23.25 9.143760681152344 21.5456714630127 6.049051284790039 18.45095062255859 C 2.954330444335938 15.35624122619629 1.250001907348633 11.24174118041992 1.250001907348633 6.865381240844727 L 1.250001907348633 4.55769157409668 C 1.250001907348633 2.733821868896484 2.733821868896484 1.250001907348633 4.55769157409668 1.250001907348633 Z" stroke="none" fill="#fff"/>
                                </g>
                            </svg>
                        </div>
                        <div className="info">
                            <h4>Phone: </h4>
                            <div className="info-inner">
                                <p><a className="contact-link" href={`tel:${contact?.phone}`}>{`T: ${contact?.phone}`}</a></p>
                                <p><a className="contact-link" href={`tel:${contact?.fax}`}>{`F: ${contact?.fax}`}</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="contact-us-map-information-item">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21">
                                <g id="Group_819" data-name="Group 819" transform="translate(-4 -2.5)">
                                    <path id="Path_14073" data-name="Path 14073" d="M19.5,11c0,7.618-7.5,12-7.5,12S4.5,18.618,4.5,11A7.762,7.762,0,0,1,12,3a7.762,7.762,0,0,1,7.5,8Z" fill="#436AB3" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                    <path id="Path_14072" data-name="Path 14072" d="M15,10.5a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z" transform="translate(0 0.441)" fill="#fff"/>
                                </g>
                            </svg>


                        </div>
                        <div className="info">
                            <h4>Office:</h4>
                            <div className="info-inner">
                                <p><a className="contact-link" href={contact?.office_link}>{contact?.office_name}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterWithSignup />
        </div>
    )
}

export default ContactUs;
